export const STANDARD_PRODUCT = 106;
export const BASIC_FEE_STANDARD = 300;
export const LEARNING_MATERIAL = 502;
export const GQC_GQD = 110;
